import React from "react";
import {
  Col,
  Row,
  Button,
} from "reactstrap";

export default function CommandButtons({
  openNewUser,
}) {
  return (
    <div style={{ paddingBottom: '10px' }}>
      <Row style={{ marginBottom: 10 }}>
        <Col lg={12}>
          <div>
            <Button
              color="primary"
              onClick={() => openNewUser()}
            >
              <span class="mdi mdi-plus" style={{ paddingRight: 5, fontSize: 17 }}></span>
              Cadastrar Usuário
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  )
}
